<template>
  <div>
    <div class="row menubar">
      <button @click="dashboard" style="float:left">
        <awesomeIcon icon="angle-left" /><span> Terug naar overzicht</span>
      </button>

      <button
        class="toggle-filters"
        :title="filtersTitle"
        @click="toggleFilters"
      >
        <awesomeIcon icon="filter" />
      </button>
      <button
        v-if="mutations !== null && mutations.length"
        @click="download"
        style="float:right;"
        title="Mutaties downloaden"
      >
        <awesomeIcon icon="download" />
      </button>
      <button
        v-if="mutations !== null && mutations.length"
        @click="windowPrint"
        style="float:right;"
        title="Mutaties printen"
      >
        <awesomeIcon icon="print" />
      </button>
      <button
        v-if="currentPort.bank === 'BVS' || currentPort.bank === 'GILI'"
        @click="depotbank = true" style="float:right"
      >
        <span>Nota's </span><awesomeIcon icon="external-link-alt" />
      </button>
    </div>

    <div class="row menubar filtersbar" ref="filtersBar">
      <input
        type="text"
        class="asset-name-input"
        placeholder="Instrument"
        title="Naam instrument"
        ref="assetName"
        v-model="assetName"
        @keydown="onTab($event, 'fromDate')"
        @keyup.enter="getMutations(true)"
      />
      <inputDropdown
        :array="groups"
        v-model="group"
        displayPrefix="Type: "
        :cb="typeDropdownCB"
        :transparent="true"
      />
      <div class="date-holder">
        <span class="filter-span">van</span>
        <input
          type="date"
          title="Datum van"
          ref="fromDate"
          v-model="fromDate"
          @keydown="onTab($event, 'tillDate')"
          style="float:none;"
        />
      </div>
      <div class="date-holder">
        <span class="filter-span">tot</span>
        <input
          type="date"
          title="Datum tot"
          ref="tillDate"
          v-model="tillDate"
          @keydown="onTab($event, 'searchButton')"
          style="float:none;"
        />
      </div>
      <button
        class="search-filters"
        title="Filters toepassen"
        ref="searchButton"
        @keyup.enter="getMutations(true)"
        @click="getMutations(true)"
      >
        <awesomeIcon icon="search" />{{ filterToggleText ? ' Filters toepassen' : '' }}
      </button>
    </div>

    <modalWindow v-if="depotbank" @close="depotbank=false" width="400">
      <div class="titlebar">Nota's</div>
      <div class="inset">
        U verlaat nu onze website en gaat naar de website van uw depotbank.
        Hier kunt u uw nota's inzien.
      </div>
      <a
        v-if="currentPort.bank == 'BVS' || currentPort.bank === 'GILI'"
        target="_blank"
        class="block-button"
        href="https://mijn.insingergilissen.nl/authentication"
      >
        InsingerGilissen <awesomeIcon icon="external-link-alt" />
      </a>
    </modalWindow>

    <modalWindow v-if="details" @close="details=false" width="600">
      <div class="titlebar">Details</div>
      <div v-if="mutation.storno" class="msg">Deze transactie is gestorneerd.</div>
      <div class="mutations-container">
        <div class="mutations-box">
          ID
          <p class="text-style">
            {{mutation.id}}
          </p>
        </div>
        <div class="mutations-box">
          Datum
          <p class="text-style">
            {{(new Date(mutation.date)).toLocaleDateString()}}
          </p>
        </div>
        <div class="mutations-box">
          Type
          <p class="text-style">
            {{mutation.class}}
          </p>
        </div>
        <div class="mutations-box">
          Instrument
          <p class="text-style" style="padding-left: 5px;padding-right: 5px;">
            {{mutation.asset_name}}
          </p>
        </div>
        <div class="mutations-box">
          Aantal
          <p class="text-style">
            {{formatPrice(mutation.quantity)}}
          </p>
        </div>
        <div class="mutations-box">
          Koers
          <p class="text-style">
            &euro; {{formatPrice(mutation.superclass === 14 ? 1 : mutation.rate)}}
          </p>
        </div>
        <div class="mutations-box">
          Belasting
          <p class="text-style">
            &euro; {{formatPrice(mutation.tax)}}
          </p>
        </div>
        <div class="mutations-box">
          Commissie
          <p class="text-style">
            &euro; {{formatPrice(mutation.commission)}}
          </p>
        </div>
        <div class="mutations-box">
          Kosten
          <p class="text-style">
            &euro; {{formatPrice(mutation.costs)}}
          </p>
        </div>
        <div class="mutations-box">
          Rente
          <p class="text-style">
            &euro; {{formatPrice(mutation.interest)}}
          </p>
        </div>
        <div class="mutations-box">
          Resultaat
          <p class="text-style">
            &euro; {{formatPrice(mutation.result)}}
          </p>
        </div>
        <div class="mutations-box">
          Totaal
          <p class="text-style">
            &euro; {{formatPrice(mutation.superclass === 14 ? mutation.rate : mutation.total)}}
          </p>
        </div>
      </div>
    </modalWindow>

    <div
      class="mutations"
      ref="mutations"
      key="mutations"
      v-if="mutations !== null && mutations.length"
    >
      <div v-if="mutations.length == 0" class="msg">
        <awesomeIcon icon="exclamation-circlet" /> Nog geen data!
      </div>
      <div v-else class="card">
        <table class="new click-tr">
          <thead class="table-legend">
            <tr>
              <th width="70">Datum</th>
              <th>Soort transactie<br>Instrument</th>
              <th class="number">Aantal<br>Koers</th>
              <th width="60" class="number">Kosten</th>
              <th width="60" class="number">Belasting</th>
              <th width="60" class="number">Resultaat</th>
              <th width="80" class="number">Totaal</th>
            </tr>
          </thead>
          <tr
            v-for="mut in mutations"
            :key="mut.id" @click="mutDetails(mut.id)"
            :class="{ 'storno': mut.storno }"
          >
            <td>{{(new Date(mut.date)).toLocaleDateString()}}</td>
            <td>
              <div class="wrap">
                {{mut.class}}
              </div>
              <div class="wrap"><strong>{{mut.asset_name}}</strong></div>
            </td>
            <td class="number">
              {{
                mut.quantity === 0
                ? '-'
                : `${formatPrice(mut.quantity, mut.quantity % 1 === 0)} x`
              }}<br>
              {{
                mut.rate === 0
                ? '-'
                : '&euro; ' + formatPrice(mut.superclass === 14 ? 1 : mut.rate)
              }}
            </td>
            <td class="number">
              {{
                mut.costs + mut.commission === 0
                ? '-'
                : '&euro; ' + formatPrice(mut.costs + mut.commission)
              }}
            </td>
            <td class="number">
              {{
                mut.tax === 0
                ? '-'
                : '&euro; ' + formatPrice(mut.tax)
              }}
            </td>
            <td class="number">
              <span v-if="mut.result > 0">+</span>
              {{
                mut.result === 0
                ? '-'
                : formatPrice(mut.result)
              }}
            </td>
            <td class="number">
              {{
                mut.total === 0 && mut.superclass !== 14
                ? '-'
                : '&euro;\xa0' + formatPrice(mut.superclass === 14 ? mut.rate : mut.total)
              }}
            </td>
          </tr>
        </table>
        <pagerElement
          :records="totalRows"
          :resultsPerPage="maxPerPage"
          v-model="currentPage"
        />
      </div>
    </div>

    <div v-else-if="mutations !== null" class="noresults">
      <span>Geen resultaten</span>
    </div>

    <div key="loader" v-else class="loader" />
  </div>
</template>

<script>
import { find } from 'lodash-es';
import FileSaver from 'file-saver';

export default {
  name: 'UserMutations',
  data() {
    return {
      mutations: null,
      mutation: null,
      details: false,
      style: process.env.VUE_APP_STYLE,
      groups: [
        {
          value: 'Alles',
        },
        {
          value: 'Transacties',
        },
        {
          value: 'Mutaties + overige',
        },
        {
          value: 'Dividenden + coupons',
        },
      ],
      dropdownlist1: false,
      depotbank: false,
      currentPage: 0,
      maxPerPage: 20,
      totalRows: 0,
      showFilters: false,
      filtersTitle: 'Filters tonen',
      assetName: null,
      fromDate: null,
      tillDate: null,
      filterToggleText: window.innerWidth < 800,
    };
  },
  computed: {
    ports() {
      return this.$store.state.ports;
    },
    port() {
      return this.$store.state.currentPort;
    },
    currentPort() {
      return find(this.ports, { id: this.port });
    },
    group: {
      get() {
        return this.$store.state.currentTransGrouping;
      },
      set(value) {
        this.$store.state.currentTransGrouping = value;
      },
    },
  },
  watch: {
    port() {
      this.getMutations(true);
    },
    currentPage() {
      this.getMutations();
    },
  },
  created() {
    this.getMutations();
  },
  methods: {
    typeDropdownCB() {
      this.getMutations(true);
    },
    onTab(event, nextInput) {
      if (event.key === 'Tab') {
        event.preventDefault();

        switch (nextInput) {
          case 'fromDate':
            this.$refs.fromDate.focus();
            break;
          case 'tillDate':
            this.$refs.tillDate.focus();
            break;
          case 'searchButton':
            this.$refs.searchButton.focus();
            break;
          default:
        }
      }
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;

      if (this.showFilters) {
        if (this.filterToggleText) {
          this.$refs.mutations.style.paddingTop = '180px';
          this.$refs.filtersBar.style.height = '146px';
        } else {
          this.$refs.filtersBar.style.height = '36px';
        }

        this.filtersTitle = 'Filters verbergen';
        setTimeout(() => {
          this.$refs.filtersBar.style.overflow = 'visible';
        }, 150);
      } else {
        if (this.filterToggleText) {
          this.$refs.mutations.style.paddingTop = '35px';
        }

        this.$refs.filtersBar.style.height = '0';
        this.filtersTitle = 'Filters tonen';
        this.$refs.filtersBar.style.overflow = 'hidden';
      }
    },
    download() {
      this.sdk.getTransactions(this.$store.state.currentPort, (response) => {
        if (response.status === 200) {
          const lineArray = [];
          lineArray.push(Object.keys(response.data.results[0]).join(';'));
          response.data.results.forEach((infoArray) => {
            const values = Object.values(infoArray).map((o, index) => {
              if (Number(o) && index !== 0 && index !== 5) {
                return this.formatPrice(Number(o));
              }
              return o;
            });
            lineArray.push(values.join(';'));
          });
          const file = new File(
            [lineArray.join('\n')],
            `${this.port}-${(new Date()).toLocaleDateString()}-mutaties.csv`,
            { type: 'text/csv;charset=utf-8' },
          );
          FileSaver.saveAs(file);
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, '', 0, -1);
    },
    dashboard() {
      this.$store.state.currentView = 'Dashboard';
    },
    mutDetails(id) {
      this.mutation = find(this.mutations, { id });
      this.details = true;
    },
    getMutations(newSearch) {
      this.mutations = null;
      let filter = [];

      if (this.fromDate) {
        filter.push(`date eqgt ${this.fromDate}`);
      }

      if (this.tillDate) {
        filter.push(`date eqlt ${this.tillDate}`);
      }

      if (this.assetName) {
        filter.push(`asset_name contains ${this.assetName}`);
      }

      switch (this.$store.state.currentTransGrouping) {
        case 'Transacties':
          filter.push('class in Aankoop,Emissie,Exercise,Lossing,Openings Aankoop,Openings Verkoop,Sluitings Aankoop,Sluitings Verkoop,Expiratie (long),Expiratie (short),Verkoop');
          break;
        case 'Dividenden + coupons':
          filter.push('class in Dividend (stock algemeen),Dividend (stock agio),Dividend (cash),Rente');
          break;
        case 'Mutaties + overige':
          filter.push('class nin Aankoop,Emissie,Exercise,Lossing,Openings Aankoop,Openings Verkoop,Sluitings Aankoop,Sluitings Verkoop,Expiratie (long),Expiratie (short),Verkoop,Dividend (stock algemeen),Dividend (stock agio),Dividend (cash),Rente');
          break;
        default:
      }

      filter = filter.join(';');

      if (newSearch) {
        this.currentPage = 0;
      }

      this.sdk.getTransactions(this.$store.state.currentPort, (response) => {
        if (response.status === 200) {
          this.mutations = response.data.results;
          this.totalRows = response.data.totalRows;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: 20px;
  @media #{$mobile} {
    padding: 1px 2px 2px;
  }
}
.mutations-container {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  > * {
    flex-grow: 1;
  }
}
.mutations-box {
  background: #fff;
  border-radius: 4px;
  margin: 10px;
  font-size: 10px;
  padding-top: 10px;
  text-align: center;
  width: 40%;
}
.menubar {
  border-radius: 0;
  input {
    width: 120px;
    display: inline-block;
    height: 36px;
  }
  .toggle-filters {
    float: right;
    border-radius: 0;
  }
}
.filtersbar {
  transition: height 0.15s;
  height: 0;
  overflow: hidden;
  background-color: #ffffff;
  border-left: 2px solid $color-highlight;
  border-right: 2px solid $color-highlight;
  &::after {
    content: '';
    width: 100%;
    height: 2px;
    background-color: $color-highlight;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .filter-span {
    padding: 10px 5px 10px 15px;
  }
  .type-dropdown {
    float: left;
    .dropdown-button:hover {
      background-color: rgba($color-background, 0.2);
    }
  }
  .search-filters {
    background-color: #ffffff;
    border-radius: 0;
    float: right;
    &:hover,
    &:focus {
      background-color: rgba($color-background, 0.2);
    }
  }
}
@media #{$desktop} {
  .text-style {
    font-size: 16px;
  }
  table {
    table-layout: fixed;
  }
  .menubar .toggle-filters {
    padding: 9px 20px 11px 20px;
  }
  .filtersbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .asset-name-input {
      flex: 1;
    }
    .type-dropdown .dropdown-button {
      background-color: #ffffff;
      border-radius: 0;
    }
  }
}
@media #{$mobile} {
  .text-style {
    white-space: nowrap;
    font-size: 11px;
  }
  .mutations {
    transition: padding 0.15s;
    padding-top: 35px;
  }
  table {
    tr td,
    tr th {
      display: none;
    }
    tr td:nth-child(2),
    tr th:nth-child(2),
    tr td:nth-child(6),
    tr th:nth-child(6) {
      display: table-cell;
    }
  }
  .filtersbar {
    top: 90px;
    input[type="date"] {
      width: calc(50% - 80px);
    }
    .asset-name-input {
      width: 100%;
      border-bottom: 1px solid $color-lightgrey;
      border-radius: 0;
    }
    .date-holder {
      width: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid $color-lightgrey;
      input {
        width: auto;
      }
    }
    .search-filters {
      width: 100%;
      svg {
        padding: 0 5px 2px 0;
      }
    }
  }
}
.wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.storno {
  text-decoration: line-through;
  color: gray;
}
.noresults {
  width: 100%;
  height: auto;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
  }
}
</style>
